import { create } from "zustand";

type NotificationBadgeState = {
  unreadCount: number;
  setUnreadCount: (count: number) => void;
};

/** Shared unread count for in-app bell + home-screen app badge. */
export const useNotificationBadgeStore = create<NotificationBadgeState>((set) => ({
  unreadCount: 0,
  setUnreadCount: (count) => set({ unreadCount: Math.max(0, count) }),
}));
